import { useEffect } from "react";
import io from "socket.io-client";

const useSocketIO = (token: string, userId: string, onMessage: (data: any) => void) => {
  useEffect(() => {
    const socket = io(process.env.REACT_APP_PENOMO_BACKEND_API, {
      query: { token, userId },
      transports: ["polling", "websocket"], // Use both polling and WebSocket transports
      reconnection: true, // Enable reconnection
    });

    socket.on("kycStatusUpdate", (data) => {
      onMessage(data);
    });

    socket.on("documentAlreadyUsed", (data) => {
      onMessage(data);
    });

    return () => {
      socket.disconnect();
    };
  }, [token, userId, onMessage]);
};

export default useSocketIO;
